<template>
    <div class="archive-list-page" v-title data-title="文章归档">
        <div class="archive-list-container">
            <!-- 返回链接 -->
            <div class="archive-nav">
                <router-link to="/blog" class="back-link">
                    <i class="el-icon-arrow-left"></i> 返回首页
                </router-link>
            </div>

            <!-- 标题区 -->
            <div class="archive-title cyber-glass-header">
                <div class="archive-icon-wrap">
                    <svg class="archive-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                        <rect x="8" y="12" width="48" height="44" rx="4" fill="none" stroke="currentColor" stroke-width="2"/>
                        <line x1="8" y1="24" x2="56" y2="24" stroke="currentColor" stroke-width="2"/>
                        <line x1="20" y1="8" x2="20" y2="20" stroke="currentColor" stroke-width="2"/>
                        <line x1="44" y1="8" x2="44" y2="20" stroke="currentColor" stroke-width="2"/>
                        <line x1="20" y1="36" x2="44" y2="36" stroke="currentColor" stroke-width="1.5"/>
                        <line x1="20" y1="44" x2="36" y2="44" stroke="currentColor" stroke-width="1.5"/>
                    </svg>
                </div>
                <h2 class="archive-title-text">文章归档</h2>
            </div>

            <!-- 按时间段查询 -->
            <div class="archive-selector archive-selector-range">
                <div class="archive-range-row">
                    <span class="archive-selector-label">时间段</span>
                    <el-select v-model="rangeStartYear" placeholder="开始年" class="archive-select archive-select-year">
                        <el-option v-for="y in yearOptions" :key="'s'+y" :label="y + '年'" :value="y"/>
                    </el-select>
                    <el-select v-model="rangeStartMonth" placeholder="开始月" class="archive-select archive-select-month">
                        <el-option v-for="m in 12" :key="'s'+m" :label="m + '月'" :value="m"/>
                    </el-select>
                    <span class="archive-range-sep">～</span>
                    <el-select v-model="rangeEndYear" placeholder="结束年" class="archive-select archive-select-year">
                        <el-option v-for="y in yearOptions" :key="'e'+y" :label="y + '年'" :value="y"/>
                    </el-select>
                    <el-select v-model="rangeEndMonth" placeholder="结束月" class="archive-select archive-select-month">
                        <el-option v-for="m in 12" :key="'e'+m" :label="m + '月'" :value="m"/>
                    </el-select>
                </div>
                <div class="archive-range-btns">
                    <el-button type="primary" class="archive-go-btn" @click="goToRange" :disabled="!rangeStartYear || !rangeStartMonth || !rangeEndYear || !rangeEndMonth">
                        查看
                    </el-button>
                    <el-button class="archive-reset-btn" @click="resetRange">
                        重置
                    </el-button>
                </div>
            </div>

            <!-- 时间段内文章列表 -->
            <div v-if="rangeQuery" class="archive-range-articles">
                <p class="archive-range-title">{{ rangeTitle }}</p>
                <article-scroll-page :query="rangeQuery"/>
            </div>

            <!-- 未按时间段查询时：加载中 / 空 / 归档列表 -->
            <div v-else-if="loading" class="archive-loading">
                正在加载…
            </div>
            <div v-else-if="archives.length === 0" class="archive-empty">
                <p class="empty-text">还没有任何归档，写几篇文章试试吧</p>
            </div>
            <ul v-else class="archive-list">
                <li v-for="a in archives" :key="a.year + '-' + a.month" class="archive-item">
                    <span class="archive-date">{{ a.year }}年{{ a.month }}月</span>
                    <span class="archive-count">{{ a.count }}篇</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {getArchives} from "@/api/article"
    import ArticleScrollPage from "@/components/common/ArticleScrollPage"

    export default {
        name: "ArchiveListPage",
        data() {
            return {
                archives: [],
                loading: true,
                rangeStartYear: null,
                rangeStartMonth: null,
                rangeEndYear: null,
                rangeEndMonth: null,
                rangeQuery: null
            }
        },
        computed: {
            yearOptions() {
                const years = new Set(this.archives.map(a => a.year));
                if (years.size > 0) {
                    return Array.from(years).sort((a, b) => b - a);
                }
                const currentYear = new Date().getFullYear();
                return Array.from({length: 10}, (_, i) => currentYear - i);
            },
            rangeTitle() {
                if (!this.rangeQuery) return "";
                return `${this.rangeQuery.startYear}年${this.rangeQuery.startMonth}月 ～ ${this.rangeQuery.endYear}年${this.rangeQuery.endMonth}月`;
            }
        },
        components: {
            "article-scroll-page": ArticleScrollPage
        },
        created() {
            this.loadArchives();
        },
        methods: {
            loadArchives() {
                this.loading = true;
                getArchives().then((res) => {
                    if (res.data.success) {
                        this.archives = res.data.data || [];
                    } else {
                        this.$message.error(res.data.msg || "这里出了点小问题，我们正在修复");
                    }
                }).catch(() => {
                    this.$message.error("网络好像有点慢，稍后再试一下吧");
                }).finally(() => {
                    this.loading = false;
                });
            },
            goToRange() {
                const sy = this.rangeStartYear;
                const sm = this.rangeStartMonth;
                const ey = this.rangeEndYear;
                const em = this.rangeEndMonth;
                if (sy > ey || (sy === ey && sm > em)) {
                    this.$message.warning("请选择有效的时间段（开始时间不能晚于结束时间）");
                    return;
                }
                this.rangeQuery = {
                    startYear: String(sy),
                    startMonth: String(sm),
                    endYear: String(ey),
                    endMonth: String(em)
                };
            },
            resetRange() {
                this.rangeStartYear = null;
                this.rangeStartMonth = null;
                this.rangeEndYear = null;
                this.rangeEndMonth = null;
                this.rangeQuery = null;
            }
        }
    }
</script>

<style scoped>
    .archive-list-page {
        margin: 40px auto 56px;
        min-width: 100%;
    }

    .archive-list-container {
        max-width: 640px;
        margin: 0 auto;
        padding: 0 20px;
        overflow: visible;
    }

    .archive-nav {
        margin-bottom: 16px;
    }

    .archive-nav .back-link {
        display: inline-flex;
        align-items: center;
        color: rgba(0, 255, 245, 0.9);
        font-size: 14px;
        text-decoration: none;
        transition: all 0.25s ease;
    }

    .archive-nav .back-link:hover {
        color: #00fff5;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.5);
    }

    .archive-title.cyber-glass-header {
        text-align: center;
        padding: 28px 20px;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 12px;
        margin-bottom: 24px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    }

    .archive-icon-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 14px;
        width: 72px;
        height: 72px;
        border-radius: 16px;
        border: 1px solid rgba(0, 255, 245, 0.4);
        background: rgba(0, 255, 245, 0.06);
        box-shadow:
            inset 0 0 20px rgba(0, 255, 245, 0.08),
            0 0 18px rgba(0, 255, 245, 0.25),
            0 0 36px rgba(0, 255, 245, 0.12);
        transition: all 0.3s ease;
    }

    .archive-title.cyber-glass-header:hover .archive-icon-wrap {
        border-color: rgba(0, 255, 245, 0.6);
        box-shadow:
            inset 0 0 24px rgba(0, 255, 245, 0.12),
            0 0 24px rgba(0, 255, 245, 0.35),
            0 0 48px rgba(0, 255, 245, 0.15);
    }

    .archive-icon {
        width: 40px;
        height: 40px;
        color: #00fff5;
        filter: drop-shadow(0 0 8px rgba(0, 255, 245, 0.5));
    }

    .archive-title-text {
        font-size: 26px;
        font-weight: 600;
        color: rgba(224, 242, 254, 0.98);
        margin: 0;
        letter-spacing: 0.5px;
    }

    .archive-selector {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 24px;
        padding: 14px 18px;
        box-sizing: border-box;
        width: 100%;
        max-width: 100%;
        overflow: visible;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 12px;
    }

    /* 年份、月份框统一宽度，月份不比年份小 */
    .archive-selector-range .archive-select-year,
    .archive-selector-range .archive-select-month {
        width: 110px !important;
        min-width: 110px !important;
        max-width: 110px !important;
    }

    /* 第一行：时间段 + 4 个选择器，保证结束月份完整显示 */
    .archive-range-row {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        min-width: 0;
        flex-wrap: wrap;
    }

    /* 按钮单独一行并居中 */
    .archive-range-btns {
        flex-basis: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin-top: 6px;
        padding-left: 0;
    }

    .archive-selector-label {
        flex-shrink: 0;
        font-size: 14px;
        color: rgba(148, 163, 184, 0.95);
        margin-right: 4px;
    }

    .archive-range-sep {
        color: rgba(0, 255, 245, 0.7);
        font-size: 14px;
    }

    .archive-range-articles {
        margin-bottom: 32px;
    }

    .archive-range-title {
        font-size: 16px;
        color: rgba(224, 242, 254, 0.9);
        margin: 0 0 16px 0;
        padding: 12px 16px;
        background: rgba(0, 255, 245, 0.06);
        border-radius: 8px;
        border: 1px solid rgba(0, 255, 245, 0.2);
    }

    .archive-select {
        flex-shrink: 0;
        min-width: 0;
    }

    .archive-select :deep(.el-input),
    .archive-select :deep(.el-input__inner) {
        width: 100% !important;
        min-width: 0;
        box-sizing: border-box;
    }

    .archive-select :deep(.el-input__inner) {
        width: 100% !important;
        background: rgba(0, 255, 245, 0.06) !important;
        border-color: rgba(0, 255, 245, 0.3) !important;
        color: rgba(224, 242, 254, 0.95) !important;
    }

    .archive-select :deep(.el-input__inner:hover),
    .archive-select :deep(.el-input__inner:focus) {
        border-color: rgba(0, 255, 245, 0.6) !important;
    }

    .archive-select :deep(.el-input__suffix .el-icon-arrow-up) {
        color: rgba(0, 255, 245, 0.8);
    }

    .archive-go-btn,
    .archive-reset-btn {
        flex-shrink: 0;
        padding: 10px 24px !important;
        font-size: 15px !important;
        min-height: 40px !important;
    }

    .archive-go-btn {
        background: rgba(0, 255, 245, 0.2) !important;
        border-color: rgba(0, 255, 245, 0.5) !important;
        color: #00fff5 !important;
    }

    .archive-go-btn:hover:not(:disabled) {
        background: rgba(0, 255, 245, 0.35) !important;
        border-color: #00fff5 !important;
        color: #fff !important;
    }

    .archive-reset-btn {
        background: transparent !important;
        border-color: rgba(148, 163, 184, 0.5) !important;
        color: rgba(203, 213, 225, 0.9) !important;
    }

    .archive-reset-btn:hover {
        border-color: rgba(0, 255, 245, 0.5) !important;
        color: #00fff5 !important;
    }

    .archive-loading {
        text-align: center;
        padding: 48px 20px;
        color: rgba(148, 163, 184, 0.9);
        font-size: 14px;
    }

    .archive-empty {
        text-align: center;
        padding: 48px 20px;
    }

    .archive-empty .empty-text {
        color: rgba(203, 213, 225, 0.85);
        font-size: 15px;
        margin: 0;
    }

    .archive-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .archive-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 20px;
        margin-bottom: 12px;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 12px;
    }

    .archive-date {
        font-size: 16px;
        font-weight: 500;
        color: rgba(224, 242, 254, 0.9);
    }

    .archive-count {
        font-size: 13px;
        color: rgba(148, 163, 184, 0.9);
        background: rgba(0, 255, 245, 0.1);
        padding: 4px 12px;
        border-radius: 10px;
    }
</style>
